import { render, staticRenderFns } from "./ModalIdentitas.vue?vue&type=template&id=99298004&scoped=true&"
import script from "./ModalIdentitas.vue?vue&type=script&lang=js&"
export * from "./ModalIdentitas.vue?vue&type=script&lang=js&"
import style0 from "./ModalIdentitas.vue?vue&type=style&index=0&id=99298004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99298004",
  null
  
)

export default component.exports